import { Caption1 } from '@fluentui/react-components';

/**
 * Why "Send this to our office" is off, when it is.
 *
 * Two different reasons, said apart (#458). Not finished: something above still needs an answer.
 * Finished but the form has not appeared yet: the button also waits for the form to show on screen
 * (`previewAvailable`), and until now that case was off with no reason given. A disabled control
 * with no explanation is the most common dead end on a form like this.
 */
export function SubmitHint({ ready, previewAvailable }: { readonly ready: boolean; readonly previewAvailable: boolean }) {
  if (!ready) return <Caption1>Finish this step above and the button will turn on.</Caption1>;
  if (!previewAvailable) return <Caption1>The form above is still loading. The button will turn on once it is showing.</Caption1>;
  return null;
}
